import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  schema?: object;
  noindex?: boolean;
}

export const SEO: React.FC<SEOProps> = ({
  title = "Daneluci Performance | Treinamento de Alta Performance",
  description = "Descubra o treinamento de alta performance com Daneluci. Treinos personalizados, consultoria e resultados reais.",
  image = "https://res.cloudinary.com/tatikka/image/upload/c_fill,w_1200,h_630,g_auto,f_auto,q_auto/v1771603992/Dudu-Daneluci-001_m0r9a6.jpg",
  url,
  type = "website",
  schema,
  noindex = false,
}) => {
  const location = useLocation();
  const siteUrl = "https://daneluci.com.br";
  // Normaliza a URL removendo a barra final (Item 057)
  const normalizedPath = location.pathname.replace(/\/$/, "");
  const currentUrl = url || `${siteUrl}${normalizedPath}`;
  const siteTitle = title.includes("Daneluci") ? title : `${title} | Daneluci Performance`;

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content="Daneluci Performance" />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />

      {/* JSON-LD Schema.org (Item 055) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};
